import React from "react";

const NumberInput = ({ value, max, min = 0, onChange }) => {
  const normalizedValue = val => {
    const newValue = parseInt(val);
    return isNaN(newValue) ? min : newValue;
  };

  const handleChange = event => {
    let newValue = normalizedValue(event.target.value);
    if (max !== undefined && newValue >= max) newValue = max;
    if (newValue <= min) newValue = min;
    onChange(newValue);
  };

  return (
    <input
      className="form-control fantastic-form-control"
      type="text"
      value={value || 0}
      onChange={handleChange}
    />
  );
};

export default NumberInput;
